// @ts-check
import balconyLocation from './filters/balconyLocation';
import balconyArea from './filters/balconyArea';
import loggiaLocation from './filters/loggiaLocation';
import loggiaArea from './filters/loggiaArea';
import content from './filters/content';
import floor from './filters/floor';
import gardenLocation from './filters/gardenLocation';
import gardenArea from './filters/gardenArea';
import houseType from './filters/houseType';
import houseModel from './filters/houseModel';
import livingArea from './filters/livingArea';
import lotArea from './filters/lotArea';
import numberOfBedrooms from './filters/numberOfBedrooms';
import numberOfRooms from './filters/numberOfRooms';
import price from './filters/price';
import status from './filters/status';
import terraceLocation from './filters/terraceLocation';
import terraceArea from './filters/terraceArea';

const filters = {
	'balcony-location': balconyLocation,
	'balcony-area': balconyArea,
	'loggia-location': loggiaLocation,
	'loggia-area': loggiaArea,
	content,
	floor,
	'garden-location': gardenLocation,
	'garden-area': gardenArea,
	'house-type': houseType,
	'house-model': houseModel,
	'living-area': livingArea,
	'lot-area': lotArea,
	'number-of-bedrooms': numberOfBedrooms,
	'number-of-rooms': numberOfRooms,
	price,
	status,
	'terrace-location': terraceLocation,
	'terrace-area': terraceArea
};

/**
 * Combines the fetchedFilters with the current values for the modal
 *
 * @param {import('../types').Filter[]} filters
 * @param {import('../types').FilterValue[]} values
 * @return {import('../types').FilterWithValue[]}
 */
const getFiltersForModal = (filters, values) => (
	filters.map(filter => {
		const foundValues = values.filter(filterValue => filterValue.name === filter.name);

		return {
			...filter,
			value: foundValues.length === 1 ? foundValues[0].value : null
		};
	})
);

/**
 * @param {string} name
 * @param {import('../types').FilterValueValue} changedValue
 * @param {import('../types').FilterValueValue} value
 * @returns {import('../types').FilterValueValue}
 */
const getUpdatedValue = (name, changedValue, value) => filters[name].getUpdatedValue(changedValue, value);
const isMatch = (name, plot, value) => !filters[name].isSet(value) || filters[name].isMatch(plot, value);
const isSet = (name, value) => filters[name].isSet(value);

const numberOfSetFilters = (filterValues) => filterValues.filter(filterValue => isSet(filterValue.name, filterValue.value)).length;

/**
 * @param {import('../types').PlotNumber[]} plotNumbers
 * @param {Array} filterState
 * @param {String} filterName
 * @param {*} filterValue
 * @returns {number} integer
 */
const getMatchCountForFilterValue = (plotNumbers, filterState, filterName, filterValue) => (
	plotNumbers.filter(plotNumber => filterState.filter(filter => isMatch(filter.name, plotNumber, filter.name === filterName ? filterValue : filter.value)).length === filterState.length).length
);

/**
 * Checks for min and max value separately and returns lowest value
 *
 * @param {import('../types').PlotNumber[]} plotNumbers
 * @param {Array} filterState
 * @param {String} filterName
 * @param {*} filterValue
 * @returns {number} integer
 */
const getMatchCountForRangeFilterValue = (plotNumbers, filterState, filterName, filterValue) => Math.min(getMatchCountForFilterValue(plotNumbers, filterState, filterName, { max: filterValue }), getMatchCountForFilterValue(plotNumbers, filterState, filterName, { min: filterValue }));

export {
	getUpdatedValue,
	getFiltersForModal,
	isMatch,
	isSet,
	numberOfSetFilters,
	getMatchCountForFilterValue,
	getMatchCountForRangeFilterValue
};